import { render } from "./Passwords.vue?vue&type=template&id=a9482494&ts=true"
import script from "./Passwords.vue?vue&type=script&lang=ts"
export * from "./Passwords.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__